export default "__VITE_ASSET__BNTqbzM$__"